import hasCookieCategoryConsent from '%paysera_service_agreement/js/CookiesUserAgreement/service/hasCookieCategoryConsent';
import { CATEGORY_STATISTICS } from '%paysera_service_agreement/js/CookiesUserAgreement/config/constants';
import LogRocket from 'logrocket';
import setupLogRocketReact from 'logrocket-react';
import { configureScope } from '@sentry/browser';

if (hasCookieCategoryConsent(CATEGORY_STATISTICS)) {
    LogRocket.init(
        'kroazc/tickets',
        {
            shouldSendData: () => environment_config.environment === 'prod',
        },
    );

    LogRocket.getSessionURL((sessionURL) => {
        configureScope((scope) => {
            scope.setExtra('sessionURL', sessionURL);
        });
    });

    setupLogRocketReact(LogRocket);
}
